import { useDispatch, useSelector } from 'react-redux';

import { TrlFormButtons } from '»components/molecules/TrlFormButtons';
import { isHemeraActiveClient } from '»utils/clientsUtils';
import { isSubmitFormButtonDisabled } from '»utils/form';

import { FormStyled } from '../Onboarding.styles';
import { onboardingLegalStatusSelector, onboardingSlice } from '../redux';
import { onboardingOpeningRequestIdSelector } from '../redux/onboarding.selectors';
import { FormWrapper } from './FormWrapper';
import { LegalPersonFields, legalPersonFormValidation } from './LegalPerson';
import {
  NaturalPersonFields,
  naturalPersonFormValidation,
} from './NaturalPerson';

export const MainForm = () => {
  const dispatch = useDispatch();

  const legalStatus = useSelector(onboardingLegalStatusSelector);
  const openingRequestId = useSelector(onboardingOpeningRequestIdSelector);

  const handleSubmit = (formValues, { setSubmitting }) => {
    const disableFormSubmittingState = () => {
      setSubmitting(false);
    };

    if (legalStatus === 'PS' || isHemeraActiveClient) {
      dispatch(
        onboardingSlice.actions.submitFinancialContractRequest({
          openingRequestId,
          formValues,
          disableFormSubmittingState,
        }),
      );
    } else {
      dispatch(
        onboardingSlice.actions.setOnboardingCurrentStep({
          direction: 'forward',
        }),
      );
      dispatch(onboardingSlice.actions.setMainFormValues(formValues));
    }
  };

  return (
    <FormWrapper
      handleSubmitForm={handleSubmit}
      formValidation={
        legalStatus === 'PS'
          ? naturalPersonFormValidation
          : legalStatus === 'PC' && legalPersonFormValidation
      }
    >
      {({ isSubmitting, dirty, errors, values }) => {
        // eslint-disable-next-line unused-imports/no-unused-vars
        const { partners, representatives, ...formValues } = values;

        return (
          <FormStyled className="formContainer flexWrap narrowFields">
            {legalStatus === 'PS' ? (
              <NaturalPersonFields />
            ) : (
              legalStatus === 'PC' && <LegalPersonFields />
            )}

            <TrlFormButtons
              fixedAtBottom
              advanceButtonName="TRLT_UI-NEXT"
              isAdvanceButtonDisabled={isSubmitFormButtonDisabled({
                isSubmitting,
                dirty,
                errors,
                values: formValues,
                areFiles: false,
              })}
            />
          </FormStyled>
        );
      }}
    </FormWrapper>
  );
};
